import { useEffect, useState, useContext } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, formatDate } from '../Helpers';
import { AiOutlineUser } from 'react-icons/ai';
import OneUser from './OneUser';

export default function OneLeagueStage(props) {
  const appContext = useContext(AppContext);
  const [ stage, setStage ] = useState(props.stage);
  const [ stageNo, setStageNo ] = useState(props.stageNo);

  const init = () => {
    //.. may be useful in the future
  }
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setStage(props.stage);
    setStageNo(props.stageNo);
  }, [ props.stage, props.stageNo ]);

  useState(() => {
    init();
  }, [ stage, stageNo ]);
  return (
    <div
      className="text-start"
      style={{
        marginTop: "20px",
        paddingTop: "10px",
        borderTop: "2px solid var(--bluish)",
        paddingBottom: "10px",
      }}
    >
      <h6 className="font-light">STAGE #{stageNo}</h6>
      <small className="text-muted">{formatDate(stage.startDate)}</small>
      {
        stage.matches.map((item, i) => {
          return (
            <div
              className="text-center z-index-1"
              style={{
                marginTop: "10px",
                marginBottom: "20px",
                border: "1px solid var(--whitish)",
                borderRadius: "10px",
                padding: "10px",
              }}
              key={i}
            >
              <OneUser id={item.players[0].id} username={item.players[0].username} simple={true} />
              <h4 style={{ marginTop: "10px", marginBottom: "10px" }}>VS</h4>
              <OneUser id={item.players[1].id} username={item.players[1].username} simple={true} />
              <hr/>
              {
                (item.gameId) ?
                <button
                  className="btn btn-sm bg-goldish text-dark"
                  onClick={() => {
                    //take to browse game
                    appContext.navTo({
                      item: "browse_game",
                      subItem: item.gameId,
                    })
                  }}
                >
                  View Game
                </button>:""
              }
            </div>
          )
        })

      }


    </div>
  )

}
